import { render, staticRenderFns } from "./Expandable.vue?vue&type=template&id=2d746d56&scoped=true&"
import script from "./Expandable.vue?vue&type=script&lang=js&"
export * from "./Expandable.vue?vue&type=script&lang=js&"
import style0 from "./Expandable.vue?vue&type=style&index=0&id=2d746d56&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d746d56",
  null
  
)

export default component.exports